/* GeneratedContentHash: 5434cce599baf4ff9544929c56be27346c7e87794533cc7c399efb8f773f7a88 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/

export const PLACEMENT_ID = 'jsm-section-header';
